module.exports = __webpack_public_path__ + "img/awards2.b507b1f4.svg";